import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import axios from 'axios';
import './Rapports.css'; 
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addRapport } from '../Redux/Actions/RapportActions';

const Rapports = () => {
  const [locations, setLocations] = useState([]);
  const [emplacement, setEmplacement] = useState('');
  const [nbrChaise, setNbrChaise] = useState(0);
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [amount, setAmount] = useState(0);
  const [expense, setExpense] = useState(0);
  const [explanation, setExplanation] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.AuthReducer.user);
  
  const ORIGINAL_WELLNESS_LOCATIONS = [
    "Champion Lafayette", "Central Park", "Palmarium", "Zaphir", "Tunis City", 
    "Azur City", "Claridge", "TP-Manar City", "TP-Tunisia Mall", "TP-Jardins D'el Menzah", 
    "Manar City", "Tunisia Mall", "Shell-Grombalia", "Shell-Sidi Khlifa", "Agil-Sidi Khlifa", 
    "Agil-Bourjin", "Agil-Jem", "Total-Sidi Khlifa", "Total-Bourjin", "Total-Jem", 
    "Sfax Palace", "Djerba Mall", "Bourgo Mall", "TP-Bourgo Mall", "Mickey Hammamet"
  ];

  // Charger les emplacements Wellness depuis le serveur
  const fetchLocations = async () => {
    try {
      const res = await axios.get('/api/Locations/getAllLocations');
      const data = Array.isArray(res.data) ? res.data : [];
      
      // Filtrer STRICTEMENT les emplacements de catégorie Wellness
      const wellnessLocs = data.filter(l => l.category === 'Wellness');
      
      const finalLocs = wellnessLocs.length > 0 
        ? wellnessLocs 
        : ORIGINAL_WELLNESS_LOCATIONS.map(name => ({ _id: name, name, category: 'Wellness' }));

      setLocations(finalLocs);

      if (finalLocs.length > 0 && !emplacement) {
        if (user?.localisation && finalLocs.some(l => l.name === user.localisation)) {
          setEmplacement(user.localisation);
        } else {
          setEmplacement(finalLocs[0].name);
        }
      }
    } catch (err) {
      console.error("Erreur chargement emplacements Wellness :", err);
      const fallback = ORIGINAL_WELLNESS_LOCATIONS.map(name => ({ _id: name, name, category: 'Wellness' }));
      setLocations(fallback);
      setEmplacement(fallback[0].name);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, [user]);

  const handleRapport = (e) => {
    e.preventDefault();

    if (!emplacement || nbrChaise <= 0 || !date || amount <= 0 || expense < 0 || !explanation) {
      alert("Veuillez remplir tous les champs correctement.");
      return;
    }

    const rapportData = {
      DateCollect : date.slice(0,10),
      localisation : emplacement,
      ChairNumber: parseInt(nbrChaise),
      Amount : parseFloat(amount),
      MonthExpenses: parseFloat(expense),
      feedback :explanation,
    };

    dispatch(addRapport(rapportData, navigate));
  };

  return (
    <div className="list-rapports container my-4" style={{ marginTop: '95px' }}>   
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
        <div>
          <h3 className="fw-bold text-primary mb-1">📝 Rapport Quotidien Wellness</h3>
          <p className="text-muted mb-0 small">Saisie des recettes et chaises de la journée</p>
        </div>

        <div>
          <Badge bg="success" className="p-2 fs-6">Saisie Caissière</Badge>
        </div>
      </div>

      <Form className="rapport-form" onSubmit={handleRapport}>
        <Card className="mb-4 shadow-sm border-primary border-2 bg-light p-3">
          <Row className="g-3">
            <Form.Group as={Col} md={6} controlId="formGridState">
              <Form.Label className="fw-bold text-primary">📍 Localisation / Emplacement</Form.Label>
              <Form.Select 
                onChange={(e) => setEmplacement(e.target.value)} 
                className="fw-bold border-primary text-dark" 
                value={emplacement}>
                {locations.length > 0 ? (
                  locations.map((loc) => (
                    <option key={loc._id} value={loc.name}>
                      {loc.name} {loc.category ? `(${loc.category})` : ''}
                    </option>
                  ))
                ) : (
                  <option value="">Chargement des emplacements...</option>
                )}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} md={6} controlId="formGridChairs">
              <Form.Label className="fw-bold text-primary">🪑 Nombre de Chaises</Form.Label>
              <Form.Control 
                onChange={(e) => setNbrChaise(e.target.value)} 
                type="number" 
                className="fw-bold border-primary text-dark" 
                min="0"
                placeholder="Nombre de chaises"
              />
            </Form.Group>
          </Row>
        </Card>

        <Card className="mb-4 shadow-sm border-0 bg-white p-3">
          <Row className="g-3 mb-3">
            <Form.Group as={Col} md={6} controlId="formGridDate">
              <Form.Label className="fw-semibold text-dark">📅 Date du Jour</Form.Label>
              <Form.Control 
                type="date" 
                className="fw-bold text-dark" 
                value={date} 
                onChange={(e) => setDate(e.target.value)}
                readOnly={user?.role !== 'admin'}
              />
            </Form.Group>

            <Form.Group as={Col} md={6} controlId="formGridAmount">
              <Form.Label className="fw-semibold text-dark">💵 Montant Total Collecté (TND)</Form.Label>
              <Form.Control 
                onChange={(e) => setAmount(e.target.value)} 
                type="number" 
                className="fw-bold text-success fs-5" 
                placeholder="Entrer le total Collecté" 
                min="0"
              />
            </Form.Group>
          </Row>

          <Form.Group controlId="formGridExpenses" className="mb-3">
            <Form.Label className="fw-semibold text-dark">💸 Dépenses Effectuées (TND)</Form.Label>
            <Form.Control 
              onChange={(e) => setExpense(e.target.value)} 
              type="number" 
              className="fw-bold text-danger" 
              min="0"
              placeholder="0.000 DT"
            />
          </Form.Group>

          <Form.Group controlId="explanationTextarea" className="mb-3">
            <Form.Label className="fw-semibold text-dark">Explication des Dépenses</Form.Label>
            <Form.Control 
              onChange={(e) => setExplanation(e.target.value)} 
              as="textarea" 
              rows={3} 
              placeholder="Saisissez vos explications ou remarques..."
            />
          </Form.Group>

          <Form.Group controlId="formGridCheckbox" className="mb-3">
            <Form.Check 
              type="checkbox" 
              label="Je confirme l'exactitude des données saisies" 
              required
              className="fw-bold text-primary"
            />
          </Form.Group>
        </Card>

        <Button onClick={(e) => handleRapport(e)} variant="primary" type="submit" className="w-100 py-3 fw-bold fs-5 shadow">
          ✅ Soumettre le Rapport Wellness
        </Button>
      </Form>
    </div>
  );
};

export default Rapports;
